/**
 * Whether ProductOrderForm has a delivery method to offer.
 *
 * When the listing type displays delivery options but the listing enables none of them — possible
 * for listings imported through the Integration API, which never set pickupEnabled/shippingEnabled
 * — the form renders only the `noDeliveryMethodSet` error and no submit button. Its own module so
 * the order panel can ask the same question without pulling the form's chunk into the main bundle.
 *
 * @param {Object} params the props ProductOrderForm receives
 * @param {boolean} params.displayDeliveryMethod
 * @param {boolean} params.pickupEnabled
 * @param {boolean} params.shippingEnabled
 * @returns {boolean}
 */
export const hasDeliveryMethod = ({ displayDeliveryMethod, pickupEnabled, shippingEnabled }) =>
  !displayDeliveryMethod || !!pickupEnabled || !!shippingEnabled;
